import script from "./PreviewSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreviewSku.vue?vue&type=script&lang=ts&setup=true"

import "./PreviewSku.vue?vue&type=style&index=0&id=1547aa97&lang=scss&scoped=true"
import "./PreviewSku.vue?vue&type=style&index=1&id=1547aa97&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1547aa97"]])

export default __exports__